"use client";
import { jsxs, jsx } from "react/jsx-runtime";
import { useState } from "react";
import { Box } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { SpaceXxs } from "@nxt-costco-com/forge-design-tokens";
import { useProductTileData } from "../../../../../hooks/useProductTileData/index.js";
import { Fulfillment } from "./Fulfillment.js";
import { ImageSwatchBlock } from "./ImageSwatchBlock.js";
import { OfferDetails } from "./OfferDetails.js";
import { ProductDetailsBlock } from "./ProductDetailsBlock.js";
import { ProgramsBlock } from "./ProgramsBlock.js";
import { cardBodyContainerStyles, cardBodyTextContentContainerStyles } from "./styles.js";
const CardBody = ({
  fsaConfig,
  showReviews,
  setPdpNavigationUrl,
  isHorizontal,
  maxImageHeight,
  productTileMaxLineNumber,
  minProductTileImageWidth,
  maxProductTileImageWidth,
  hideReviewStarValue,
  pdpNavigationUrl,
  showActionButton = true,
  ratingVariant,
  isCriteo = false,
  enablePromoBreakdown
}) => {
  var _a;
  const {
    isInformative,
    normalizedData,
    translationsConfig,
    productTitleId
  } = useProductTileData();
  const isMinWidthOrGreater = useMediaQuery("(min-width:360px)");
  const {
    productInfoData,
    isMemberOnlyItem,
    isFsaEligible,
    reviewRatingData,
    pillBadges,
    colorSwatchesData
  } = normalizedData;
  const translations = translationsConfig == null ? void 0 : translationsConfig.translations;
  const { productImageUrl, productName, partNumber } = productInfoData;
  const [imageUrl, setImageUrl] = useState(productImageUrl);
  const [onPreviewImageUrl, setOnPreviewImageUrl] = useState(null);
  const onSwatchClick = (swatchData) => {
    const { pdpNavigationUrl: pdpNavigationUrl2, productImageUrl: productImageUrl2 } = swatchData || {};
    setImageUrl(productImageUrl2);
    setPdpNavigationUrl(pdpNavigationUrl2);
  };
  const onRemovePreview = () => {
    setOnPreviewImageUrl(null);
  };
  const onSwatchPreview = (swatchData) => {
    const { productImageUrl: productImageUrl2 } = swatchData || {};
    setOnPreviewImageUrl(productImageUrl2);
  };
  return /* @__PURE__ */ jsxs(
    Box,
    {
      sx: [
        cardBodyContainerStyles,
        {
          flexDirection: isHorizontal ? "row" : "column",
          minWidth: isMinWidthOrGreater ? "140px" : 0
        }
      ],
      children: [
        /* @__PURE__ */ jsx(
          Box,
          {
            sx: {
              ...cardBodyTextContentContainerStyles,
              minWidth: isHorizontal ? minProductTileImageWidth : void 0,
              maxWidth: isHorizontal ? maxProductTileImageWidth : void 0
            },
            children: /* @__PURE__ */ jsx(
              ImageSwatchBlock,
              {
                colorSwatchesData,
                imageUrl,
                isHorizontal,
                maxImageHeight,
                minProductTileImageWidth,
                maxProductTileImageWidth,
                onPreviewImageUrl,
                onRemovePreview,
                onSwatchClick,
                onSwatchPreview,
                partNumber,
                productName,
                productTitleId,
                translations
              }
            )
          }
        ),
        /* @__PURE__ */ jsxs(
          Box,
          {
            sx: {
              ...cardBodyTextContentContainerStyles,
              flex: 1
            },
            children: [
              /* @__PURE__ */ jsxs(
                Box,
                {
                  sx: {
                    ...cardBodyTextContentContainerStyles,
                    marginBottom: SpaceXxs
                  },
                  children: [
                    /* @__PURE__ */ jsx(
                      ProgramsBlock,
                      {
                        fsaConfig,
                        isFsaEligible,
                        isMemberOnlyItem,
                        partNumber,
                        pdpNavigationUrl,
                        pillBadges
                      }
                    ),
                    /* @__PURE__ */ jsx(
                      ProductDetailsBlock,
                      {
                        hideReviewStarValue,
                        partNumber,
                        productTileMaxLineNumber: ((_a = translationsConfig == null ? void 0 : translationsConfig.product_display_style) == null ? void 0 : _a.description_max_line_numbers) || productTileMaxLineNumber,
                        ratingVariant,
                        reviewRatingData,
                        showReviews,
                        emptyReviewText: translations.noreviews
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ jsxs(
                Box,
                {
                  sx: {
                    ...cardBodyTextContentContainerStyles,
                    flex: 1,
                    justifyContent: "flex-end"
                  },
                  children: [
                    /* @__PURE__ */ jsx(
                      OfferDetails,
                      {
                        productTileMaxLineNumber,
                        enablePromoBreakdown
                      }
                    ),
                    /* @__PURE__ */ jsx(
                      Fulfillment,
                      {
                        isCriteo,
                        isInformative,
                        pdpNavigationUrl,
                        showActionButton
                      }
                    )
                  ]
                }
              )
            ]
          }
        )
      ]
    }
  );
};
export {
  CardBody
};
